"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";

interface PriceItem {
  city: string;
  slug: string;
  price: string;
  href: string;
}

interface PriceListProps {
  prices: PriceItem[];
  hidePrice?: boolean;
  trackingClass?: string;
  title: string;
  modelName?: string;
}

const PriceList = ({
  prices,
  hidePrice = false,
  trackingClass,
  title,
  modelName,
}: PriceListProps) => {
  const [showAll, setShowAll] = useState(false);

  const visiblePrices = showAll ? prices : prices.slice(0, 5);

  return (
    <>
      <div className="flex-1">
        {visiblePrices.map((item, i) => (
          <div
            key={`${item.city}-${i}`}
            className={`flex justify-between items-center px-4 py-4 ${
              i % 2 !== 0 ? "bg-[#F9FAFB]" : "bg-white"
            }`}
          >
            <Link
              prefetch={false}
              href={item.href}
              title={modelName ? `${modelName} Price in ${item.city}` : item.city}
              className={`font-roboto font-[500] text-[15px] text-[#155DFC] hover:underline ${
                trackingClass || ""
              }`}
            >
              {item.city}
            </Link>

            <p
              className={`font-roboto font-[500] text-[13px] leading-[20px] text-[#101828] ${
                hidePrice ? "blur-[4px] select-none pointer-events-none" : ""
              }`}
            >
              {item.price} {item.price !== 'Price to be Announced' && <span className="text-[11px] text-[#62748E] font-normal ml-0.5"> onwards</span>} 
            </p>
          </div>
        ))}
      </div>

      {!showAll && prices.length > 5 && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="flex w-full items-center justify-center gap-2 border-t border-[#EDF0F3] bg-[#FBFCFD] py-3 text-center text-[13px] font-bold text-[#344054] transition-colors"
        >
          View More
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}view-all-arrow.svg`}
            alt={title}
            title={title}
            width={20}
            height={20}
            className="invert rotate-90"
          />
        </button>
      )}
    </>
  );
};

export default PriceList;
